import { DesktopShell } from "@circleco/compass/components/DesktopShell";
import { type ReactNode } from "react";

import { DOM_IDS } from "./defaults";

interface CompassShellBodyProps {
  children: ReactNode;
  resizable?: boolean;
}

export const CompassShellBody = ({
  children,
  resizable = true,
}: Readonly<CompassShellBodyProps>) => (
  <DesktopShell.Body
    id={DOM_IDS.shellBody}
    data-testid={
      resizable ? "circle-ai-shell-layout-body" : "circle-ai-shell-layout-grid"
    }
    resizable={resizable}
  >
    {children}
  </DesktopShell.Body>
);

CompassShellBody.displayName = "CircleAIAppShell.Layout.ShellBody";
